const ValidationErrors = (props) => {
    return (
        props.validationErrors && (
            <div className={props.className? props.className:"validation-errors alert alert-danger col-8"} role="alert" ref={props.passRef}>
                {props.validationErrors.map((error, index) => (
                    <div className={`validation-error-${index}`} key={index}>
                        {error}
                    </div>
                ))}
            </div>
        )
    );
}

export default ValidationErrors;